import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


import App from './App';
import './index.module.css'; // Importing global styles

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode clasName="textStyle">
    <App />
  </React.StrictMode>
);


